import { atom } from "recoil";

interface WritingDetailInfo {
  genre: string;
  detailedGenre: string;
  age: number;
  suggestedThemes: string[];
  mainTheme: string;
  questions: string[];
  answers: string[];
  words: string;
  sentences: string;
}

export const writingDetailInfoAtom = atom<WritingDetailInfo>({
  key: "writingDetailInfoAtom",
  default: {
    genre: "",
    detailedGenre: "",
    age: 0,
    mainTheme: "",
    suggestedThemes: [],
    questions: [],
    answers: [],
    words: "",
    sentences: "",
  },
});
